import { render, staticRenderFns } from "./UpsertCertificateType.vue?vue&type=template&id=37f4b6f3&scoped=true"
import script from "./UpsertCertificateType.vue?vue&type=script&lang=ts"
export * from "./UpsertCertificateType.vue?vue&type=script&lang=ts"
import style0 from "./UpsertCertificateType.vue?vue&type=style&index=0&id=37f4b6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4b6f3",
  null
  
)

export default component.exports